/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tags_Offerscount1Inputs */

const id_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} penawaran tersedia di acara ini`)
};

const ms_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tawaran tersedia dalam acara ini`)
};

const da_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tilbud tilgængelige i denne begivenhed`)
};

const de_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Angebote in dieser Aktion verfügbar`)
};

const en_us2_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} offers available in this event`)
};

const es_es2_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} juegos disponibles en este evento`)
};

const es_mx2_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ofertas disponibles en este evento`)
};

const fil_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} offer na available sa event na ito`)
};

const fr_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} offres disponibles dans cet événement`)
};

const it_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} offerte disponibili in questo evento`)
};

const hu_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ajánlat elérhető ebben az eseményben`)
};

const nl_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} aanbiedingen beschikbaar in dit evenement`)
};

const no_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tilbud tilgjengelig i dette arrangementet`)
};

const pl_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ofert dostępnych w tym wydarzeniu`)
};

const pt_br2_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} jogos disponíveis neste evento`)
};

const pt_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ofertas disponíveis neste evento`)
};

const ro_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} oferte disponibile în acest eveniment`)
};

const fi_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tarjousta saatavilla tässä tapahtumassa`)
};

const sv_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} erbjudanden tillgängliga i detta evenemang`)
};

const vi_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ưu đãi có sẵn trong sự kiện này`)
};

const tr_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu etkinlikte ${i?.count} teklif mevcut`)
};

const cs_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`V této události je k dispozici ${i?.count} nabídek`)
};

const bg_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} оферти налични в това събитие`)
};

const ru_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} предложений доступно в этой акции`)
};

const uk_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} пропозицій доступно в цій події`)
};

const ar_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} عرض متاح في هذا الحدث`)
};

const hi_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इस ईवेंट में ${i?.count} ऑफ़र उपलब्ध हैं`)
};

const th_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`มี ${i?.count} ข้อเสนอในอีเวนต์นี้`)
};

const ja_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このイベントでは ${i?.count} 件のオファーが利用可能`)
};

const zh_cn2_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`此活动包含 ${i?.count} 个目录项`)
};

const zh_hant1_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`此活動包含 ${i?.count} 個目錄項目`)
};

const ko_tags_offerscount1 = /** @type {(inputs: Tags_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`이 이벤트에서 이용 가능한 ${i?.count}개의 오퍼`)
};

/**
* | output |
* | --- |
* | "{count} offers available in this event" |
*
* @param {Tags_Offerscount1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_offerscount1 = /** @type {((inputs: Tags_Offerscount1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Offerscount1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_offerscount1(inputs)
	if (locale === "ms") return ms_tags_offerscount1(inputs)
	if (locale === "da") return da_tags_offerscount1(inputs)
	if (locale === "de") return de_tags_offerscount1(inputs)
	if (locale === "en-US") return en_us2_tags_offerscount1(inputs)
	if (locale === "es-ES") return es_es2_tags_offerscount1(inputs)
	if (locale === "es-MX") return es_mx2_tags_offerscount1(inputs)
	if (locale === "fil") return fil_tags_offerscount1(inputs)
	if (locale === "fr") return fr_tags_offerscount1(inputs)
	if (locale === "it") return it_tags_offerscount1(inputs)
	if (locale === "hu") return hu_tags_offerscount1(inputs)
	if (locale === "nl") return nl_tags_offerscount1(inputs)
	if (locale === "no") return no_tags_offerscount1(inputs)
	if (locale === "pl") return pl_tags_offerscount1(inputs)
	if (locale === "pt-BR") return pt_br2_tags_offerscount1(inputs)
	if (locale === "pt") return pt_tags_offerscount1(inputs)
	if (locale === "ro") return ro_tags_offerscount1(inputs)
	if (locale === "fi") return fi_tags_offerscount1(inputs)
	if (locale === "sv") return sv_tags_offerscount1(inputs)
	if (locale === "vi") return vi_tags_offerscount1(inputs)
	if (locale === "tr") return tr_tags_offerscount1(inputs)
	if (locale === "cs") return cs_tags_offerscount1(inputs)
	if (locale === "bg") return bg_tags_offerscount1(inputs)
	if (locale === "ru") return ru_tags_offerscount1(inputs)
	if (locale === "uk") return uk_tags_offerscount1(inputs)
	if (locale === "ar") return ar_tags_offerscount1(inputs)
	if (locale === "hi") return hi_tags_offerscount1(inputs)
	if (locale === "th") return th_tags_offerscount1(inputs)
	if (locale === "ja") return ja_tags_offerscount1(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_offerscount1(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_offerscount1(inputs)
	return ko_tags_offerscount1(inputs)
});
export { tags_offerscount1 as "tags.offersCount" }